import { render, staticRenderFns } from "./CertDataProcessor.vue?vue&type=template&id=5c52bb76&"
import script from "./CertDataProcessor.vue?vue&type=script&lang=js&"
export * from "./CertDataProcessor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports